import { useState } from 'react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useLazyGetExtractExportFileQuery, useLazyGetExtractExportFileV2Query, } from '../../services/extractApi/extractApi';
function hasFileContent(file) {
    return !!file?.data?.length;
}
export function useGetExtractExportFile() {
    const [trigger] = useLazyGetExtractExportFileQuery();
    const [triggerV2] = useLazyGetExtractExportFileV2Query();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [exportExtractFile, setExportExtractFile] = useState(undefined);
    async function getExtractExportFile(startDate, endDate, format) {
        setLoading(true);
        setError(false);
        setExportExtractFile(undefined);
        const showDailyBalance = isFeatureFlagWhiteListed(FeatureFlagUseCase.COREBANKING_EXTRACT_DAILY_BALANCE);
        const isBaasV2 = isFeatureFlagWhiteListed(FeatureFlagUseCase.CORE_BANKING_ENABLE_BAAS_V2);
        try {
            if (isBaasV2) {
                const partyId = getSelectedAccountInfo()?.targetId ?? undefined;
                const { data } = await triggerV2({ startDate, endDate, format, showDailyBalance, partyId });
                if (hasFileContent(data?.result)) {
                    setExportExtractFile(data.result);
                }
                else {
                    setError(true);
                }
            }
            else {
                const { data } = await trigger({ startDate, endDate, format, showDailyBalance });
                if (hasFileContent(data?.result)) {
                    setExportExtractFile(data.result);
                }
                else {
                    setError(true);
                }
            }
        }
        catch {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        exportExtractFile,
        setExportExtractFile,
        getExtractExportFile,
    };
}
